import { COLORS } from '@r1-frontend/ui-react/assets/js/constants';
import GridContainer from '@r1-frontend/ui-react/components/layouts/gridContainer';
import { FONTS } from '@r1-frontend/ui-react/tokens/fonts';
import styled from 'styled-components';

import backWifi from './back-wifi.jpg';

export const customStylesSelect = (hasImage) => ({
    container: (base) => ({
      ...base,
      width: '100%',
    }),
    valueContainer: (base) => ({
        ...base,
        paddingLeft: hasImage ? '36px !important' : '16px !important',
        /* @TODO Добавить иконку в либу и убрать base64 */
        background: hasImage
            ? 'url(data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjIiIGhlaWdodD0iMjIiIHZpZXdCb3g9IjAgMCAyMCAyMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnI' +
            'j4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik04LjMzNDEgMTUuNjY2N0MxMi4zODQ2IDE1LjY2NjcgMTUuNjY4MiAxMi' +
            '4zODM0IDE1LjY2ODIgOC4zMzMzM0MxNS42NjgyIDQuMjgzMjUgMTIuMzg0NiAxIDguMzM0MSAxQzQuMjgzNTkgMSAxIDQuMjgzMjUgMSA4LjMzMzMzQzEgMTIuMzg' +
            'zNCA0LjI4MzU5IDE1LjY2NjcgOC4zMzQxIDE1LjY2NjdaIiBzdHJva2U9IiM5Nzk3OTciIHN0cm9rZS13aWR0aD0iMS4zIi8+CjxwYXRoIGQ9Ik0xMy41IDEzLjVM' +
            'MTcuMjUgMTcuMjUiIHN0cm9rZT0iIzk3OTc5NyIgc3Ryb2tlLXdpZHRoPSIxLjMiLz4KPC9zdmc+Cg==) no-repeat left 10px center'
: '',
    }),
});

export const Wifi = styled.div`
    display: block;
    position: relative;
    width: 100%;
    margin-top: 12px;
    margin-bottom: -50px;
    padding-top: 10px;
    padding-bottom: 60px;
    color: ${COLORS.black};
    background-color: ${COLORS.white};
    overflow: hidden;
`;

export const InnerContainer = styled(GridContainer)`
    margin: 0 auto;
    width: 100%;
    max-width: 985px;
    min-width: 320px;
`;

export const Head = styled.div`
    padding: 150px 0 100px;
    background-image: url(${backWifi});
    background-size: cover;
    background-repeat: no-repeat;
`;

export const Title = styled.h1`
    margin-top: 0;
    margin-bottom: 30px;
    width: 100%;
    color: ${p => p.isLight ? COLORS.white : COLORS.black};
    ${FONTS.H1};

    @media only screen and (max-width: 640px) {
        ${FONTS.H2};
    }
`;

export const Desc = styled.div`
    width: 100%;
`;

export const DescElem = styled.div`
    position: relative;
    max-width: 845px;
    width: 100%;
    margin-bottom: 20px;
    padding-left: 80px;

    &::before {
        position: absolute;
        top: -5px;
        left: 0;
        z-index: 1;
        content: '';
        width: 50px;
        height: 50px;
        font-family: 'icomoon';
        color: ${COLORS.white};
        font-size: 50px;
        line-height: 1;
    }

    @media only screen and (max-width: 1187px) {
        padding-left: 45px;

        &::before {
            top: 0;
            font-size: 30px;
        }
    }
`;

export const DescElemWifi = styled(DescElem)`
    &::before {
        content: '\\e613';
    }
`;

export const DescElemInternet = styled(DescElem)`
    &::before {
        content: '\\e610';
    }
`;

export const DescTitle = styled.h2`
    margin-bottom: 20px;
    width: 100%;
    ${FONTS.H2};
    color: ${COLORS.white};
`;

export const DescText = styled.p`
    margin-bottom: 20px;
    width: 100%;
    ${FONTS.XS};
    color: ${p => p.isLight ? COLORS.white : COLORS.black};
`;

export const DescLink = styled.a`
    width: 100%;
    ${FONTS.MediumS};
    border-bottom-color: #cce4fb;
    color: ${p => p.isDark ? '#007AE5' : '#cce4fb'};
    text-decoration: underline;
    transition: color .2s linear;
    cursor: pointer;

    &:hover {
        border-bottom-color: #f38a8e;
        color: #f38a8e;
    }
`;

export const FilterWrap = styled.div`
    align-items: center;
    width: 100%;
    padding: 40px 0 20px;
`;

export const SelectWrap = styled.div`
    position: relative;
    flex: 1 0 270px;
    max-width: 420px;
    margin-right: 30px;
    margin-bottom: 20px;

    &:last-of-type {
        margin-right: 0;
    }

    @media only screen and (max-width: 640px) {
        margin-right: 0;
    }
`;

export const MapWrap = styled.div`
    margin-bottom: 50px;
    overflow: hidden;
    height: 420px;

    @media only screen and (max-width: 640px) {
        height: 340px;
    }
`;

export const ContactsWrap = styled.div``;

export const GuideName = styled.div`
    margin-bottom: 25px;
    width: 100%;
    ${FONTS.XL};
`;

export const Guide = styled.div`
    display: flex;
    flex-wrap: nowrap;

    @media only screen and (max-width: 640px) {
        flex-direction: column;
    }
`;

export const GuideElem = styled.div`
    flex: 0 1 33%;
    display: flex;
    flex-direction: column;
    margin-right: 3.6%;

    &:last-of-type {
        margin-right: 0;
    }
`;

export const GuideTitle = styled.div`
    margin-top: 15px;
    margin-bottom: 20px;
    ${FONTS.XS};
    color: ${COLORS.black};
`;

export const GuideNum = styled.div`
    width: 100%;
    ${FONTS.H1};
    color: #00993b;
`;
